import React from 'react';
import PropTypes from 'prop-types';

export const NUMBER_OF_TICKS = 40;
export const TICK_INCREMENT_PC = 100 / NUMBER_OF_TICKS;

export default function SliderScale({ className, setRef }) {
  const TICK_SEQUENCE = Array.from(
    { length: NUMBER_OF_TICKS + 1 },
    (_, i) => Math.round(i * TICK_INCREMENT_PC * 10) / 10
  );

  return (
    <svg
      ref={setRef}
      className={className}
      role="presentation"
      width="100%"
      height="33"
      xmlns="http://www.w3.org/2000/svg"
      overflow="visible">
      <g transform="translate(0,14)">
        {TICK_SEQUENCE.map(inc => {
          const majorIncrement = inc % 25 === 0;

          return (
            <rect
              key={inc}
              className={`tick tick__${majorIncrement ? 'major' : 'minor'}`}
              x={`${inc}%`}
              y={majorIncrement ? '-1' : '1'}
              width={majorIncrement ? '2' : '1'}
              height={majorIncrement ? '12' : '8'}
            />
          );
        })}
      </g>
    </svg>
  );
}

SliderScale.propTypes = {
  className: PropTypes.string,
};

SliderScale.defaultProps = {
  className: '',
};
